/**
 * Zoom user roles used in webinars
 */
export enum ZOOM_ROLES {
  ATTENDEE = 0,
  HOST = 1,
  ASSISTANT = 5,
}

/**
 * Stand levels by subscription type
 */
export enum STAND_LEVELS {
  SPONSOR,
  BASIC,
  ADVANCED,
  ADVANCED_PLUS,
}

/**
 * Cookies variables
 */
export enum COOKIES {
  COOKIES_ACCEPTED = "cookies_accepted",
  INTRO_VIDEO = "intro_video",
  SIGNUP_TUTORIALS = "signup_tutorials",
}

/**
 * Events statuses
 */
export enum EVENTS_STATUSES {
  STATUS_NEXT,
  STATUS_OVER
}

/**
 * Stand media type, used in stand details
 */
export enum STAND_MEDIA_TYPES {
  IMAGE,
  VIDEO,
}

/**
 * User roles
 */
export enum USER_ROLES {
  ADMIN = "admin",
  STAND = "stand",
  VISITOR = "visitor",
}
